import { toast } from "react-toastify";

import {
  fetchChargingSessionRequest,
  fetchChargingSessionSuccess,
  fetchChargingSessionFailure,
} from "./reducer";

import { GET_ALL_CHARGING } from "../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../interceptor/interceptor";

export const getAllChargingSession =
  (filter, first = 10, offset = 0, setLoading) =>
  async (dispatch) => {
    try {
      setLoading?.(true);

      dispatch(fetchChargingSessionRequest());

      const payload = {
        query:
          "query($filter: ChargingSessionReportFilter, $first: Int, $offset: Int) { ChargingSessionReport(filter: $filter, first: $first, offset: $offset) { totalCount records { sessionId stationId stationName connectorId customerMobileNumber startTimestamp endTimestamp duration energyDelivered startSoc endSoc maxChargingPower avgChargingPower sessionStatus stopReason tariffPlanApplied amountCharged tax totalAmount } } }",
        variables: {
          filter,
          first,
          offset,
        },
      };

      const response = await determineBaseUrlAndPerformApiCall(
        GET_ALL_CHARGING,
        "POST",
        payload
      );

      if (response?.error) {
        dispatch(fetchChargingSessionFailure(response.error.message));
        toast.error(response.error.message);
        return;
      }

      dispatch(fetchChargingSessionSuccess(response));
    } catch (error) {
      dispatch(fetchChargingSessionFailure("Something went wrong"));
      toast.error("Something went wrong");
    } finally {
      setLoading?.(false);
    }
  };